/* Caseonl design behaviours — sticky header state, staggered grid entrances,
   cart-count feedback. Deliberately tiny and dependency-free; all of it
   degrades to "no animation" rather than "no content". */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Header gains a shadow once you leave the top of the page, so it reads as
     floating above the content rather than welded to it. */
  function stickyHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('cx-stuck', window.scrollY > 12);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* Product grids animate in per-item the first time they enter view. */
  function staggerGrids() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var grids = document.querySelectorAll(
      '.product-grid, .collection__products, .cx-cats__grid, .cx-props__grid'
    );
    if (!grids.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cx-stagger');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    grids.forEach(function (g) { io.observe(g); });
  }

  /* Pulse the cart bubble whenever the count actually changes — a small,
     honest confirmation that the add worked. */
  function cartFeedback() {
    var bubble = document.querySelector('.cart-count-bubble');
    if (!bubble || reduced) return;
    var last = bubble.textContent.trim();
    var mo = new MutationObserver(function () {
      var now = bubble.textContent.trim();
      if (now !== last) {
        last = now;
        bubble.classList.remove('cx-bump');
        void bubble.offsetWidth; // restart the animation
        bubble.classList.add('cx-bump');
      }
    });
    mo.observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  function boot() {
    stickyHeader();
    staggerGrids();
    cartFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
